import Hero from './components/Hero'
// import About from './components/About'
import Skills from './components/Skills'
import Projects from './components/Projects'
import WorkExperience from './components/WorkExperience'
import Contact from './components/Contact'
import Testimonials from './components/Testimonials'
import Certifications from './components/Certifications'
import Pricing from './components/Pricing'
import Education from './components/Education'

// import Footer from './components/Footer'
export default function App() {
  return (
    <div className="overflow-x-hidden">
      <Hero />
      {/* <About /> */}
      <Skills />
      <Projects />
      <WorkExperience />
      <Pricing/>
      <Testimonials/>
      <Certifications />
      <Education/>
      <Contact />
      {/* <Footer /> */}
    </div>
  )
}
